export enum OtpMethod {
  SMS = "phone",
  EMAIL = "email",
  MFA = "2FA",
}

export const OtpMethodDetail = {
  [OtpMethod.SMS]: {
    value: 1,
    label: "Sử dụng số điện thoại",
  },
  [OtpMethod.EMAIL]: {
    value: 2,
    label: "Sử dụng email",
  },
  [OtpMethod.MFA]: {
    value: 3,
    label: "Sử dụng phương thức MFA",
  },
};
